import { ACTIONS, ASSESSMENTS, COMPLIANCE_REQUIREMENTS, EVIDENCE, EXCEPTIONS, EXPORTS, GOVERNANCE, ISSUES, OPERATIONAL_CONTROLS, RISKS, RISK_REGISTER, SERVICES, THIRD_PARTIES, TPRM } from 'Config/Paths';
import { Action } from 'Models/Actions';
import { ExceptionExportResponse } from 'Models/Exceptions';
import { DueDiligenceWorkflowExportRow, EvidenceExportRow, GovernanceExportRow, OperationalControlExportRow, RequirementExportRow, RiskAssessmentExportRow, RiskExportRow } from 'Models/Exports';
import { IssueExportResponse } from 'Models/Issues';
import { AssessmentAndAssessmentHistoryExportResponse } from 'Models/OperationalControls';
import { PaginatedResponseModel, ResponseModel } from 'Models/ResponseModel';
import { restApiGet } from 'RestApiConnector';

import { ExportsApi } from './ExportsApi';

export class AWSExportApi implements ExportsApi {
    getGovernanceExport = (): Promise<ResponseModel<GovernanceExportRow[]>> => {
        return restApiGet(`/${EXPORTS}/${GOVERNANCE}`, {});
    };

    getIssuesExport = (): Promise<ResponseModel<IssueExportResponse[]>> => {
        return restApiGet(`/${EXPORTS}/${ISSUES}`, {});
    };

    getExceptionsExport = (): Promise<ResponseModel<ExceptionExportResponse[]>> => {
        return restApiGet(`/${EXPORTS}/${EXCEPTIONS}`, {});
    };

    getOperationalControlExport = (): Promise<ResponseModel<OperationalControlExportRow[]>> => {
        return restApiGet(`/${EXPORTS}/${OPERATIONAL_CONTROLS}`, {});
    };

    getEvidenceControlExport = (): Promise<ResponseModel<EvidenceExportRow[]>> => {
        return restApiGet(`/${EXPORTS}/${OPERATIONAL_CONTROLS}/${EVIDENCE}`, {});
    };

    getControlAssessmentsExport = (): Promise<ResponseModel<AssessmentAndAssessmentHistoryExportResponse[]>> => {
        return restApiGet(`/${EXPORTS}/${OPERATIONAL_CONTROLS}/${ASSESSMENTS}`, {});
    };

    getComplianceRequirementsExport = (nextPage?: string): Promise<PaginatedResponseModel<RequirementExportRow[]>> => {
        return restApiGet(`/${EXPORTS}/${COMPLIANCE_REQUIREMENTS}`, { next_page: nextPage });
    };

    getThirdPartyServiceDueDiligenceWorkflowsExport = (): Promise<ResponseModel<DueDiligenceWorkflowExportRow[]>> => {
        return restApiGet(`/${EXPORTS}/${TPRM}/${THIRD_PARTIES}/${SERVICES}/${ASSESSMENTS}`, {});
    };

    getActionsExport = (): Promise<ResponseModel<Action[]>> => {
        return restApiGet(`/${EXPORTS}/${ACTIONS}`, {});
    };

    getRisksExport = (): Promise<ResponseModel<RiskExportRow[]>> => {
        return restApiGet(`/${EXPORTS}/${RISK_REGISTER}/${RISKS}`, {});
    };

    getRiskAssessmentsExport = (): Promise<ResponseModel<RiskAssessmentExportRow[]>> => {
        return restApiGet(`/${EXPORTS}/${RISK_REGISTER}/${ASSESSMENTS}`, {});
    };
}
